import { CreateButton } from "react-admin";
import TreeNodeCreate from "./Create";
import TreeNodeEdit from "./Edit";
import { TreeWithDetails } from "@react-admin/ra-tree";

const TreeList = ({ name }) => {
  return (
    <TreeWithDetails
      sx={{
        display: "flex",
        flexWrap: "wrap",
        "& .RaTreeWithDetails-cardTree": {
          minWidth: "fit-content",
        },
        "& .RaTreeWithDetails-actionCard": {
          width: "initial",
          flexGrow: 1,
        },
        "& .MuiPaper-root": {
          width: "fit-content",
        },
      }}
      draggable
      showLine
      create={<TreeNodeCreate name={name} />}
      edit={<TreeNodeEdit name={name} />}
      addRootButton={<CreateButton />}
    />
  );
};

export default TreeList;
